import { render, staticRenderFns } from "./ComparisonGallery.vue?vue&type=template&id=825f67ae&"
import script from "./ComparisonGallery.vue?vue&type=script&lang=js&"
export * from "./ComparisonGallery.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonGallery.vue?vue&type=style&index=0&id=825f67ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports